import { render, staticRenderFns } from "./SuccessPopup.vue?vue&type=template&id=5befa1c9&scoped=true&"
import script from "./SuccessPopup.vue?vue&type=script&lang=js&"
export * from "./SuccessPopup.vue?vue&type=script&lang=js&"
import style0 from "./SuccessPopup.vue?vue&type=style&index=0&id=5befa1c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5befa1c9",
  null
  
)

export default component.exports